// @flow

/**
 * Module dependencies.
 */

import { identity } from 'lodash';

/**
 * Zendesk entities.
 */

export default function zendeskEntities(translate: Function = identity): Object {
  return {
    currencies: [{
      code: 'USD',
      symbol: '$',
      value: 'usd'
    }, {
      code: 'EUR',
      symbol: '€',
      value: 'eur'
    }, {
      code: 'AOA',
      symbol: 'Kz',
      value: 'aoa'
    }],
    currenciesGroup1: ['USD', 'EUR'],
    currenciesGroup2: ['AOA'],
    defaultValues: {
      amount: '',
      fromCurrency: 'usd',
      reason: 'customer_registration',
      toCurrency: 'aoa',
      toCurrencyPrefix: 'to_'
    },
    mailSubjects: {
      contact: 'Wayfex Contact',
      transferRequest: 'Wayfex Transfer Request'
    },
    reasons: [{
      label: translate('reasons.customerRegistration'),
      value: 'customer_registration'
    }, {
      label: translate('reasons.agentRegistration'),
      value: 'agent_registration'
    }, {
      label: translate('reasons.support'),
      value: 'support'
    }, {
      label: translate('reasons.compliance'),
      value: 'compliance'
    }, {
      label: translate('reasons.currenciesMarkets'),
      value: 'currencies___markets'
    }, {
      label: translate('reasons.licenseRepresentatives'),
      value: 'license_representatives'
    }, {
      label: translate('reasons.other'),
      value: 'other'
    }],
    switchedCurrencies: false
  };
}



// WEBPACK FOOTER //
// ../src/client/core/entities/zendesk.js